import React from "react";
import { Card, Typography } from "@kelp-dao/kernel-design-system";
import BaseImage from "@components/BaseImage";

export interface FeatureCardProps {
  icon: string;
  title: string;
  description: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  title,
  description,
}) => {
  return (
    <Card
      variant="non-bordered"
      className="flex flex-row md:flex-col justify-start md:justify-between gap-4 md:gap-0 rounded-[12px] p-4 md:p-6 lg:p-6 min-h-auto md:min-h-[241px] lg:min-h-[239px] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_2px_8px_rgba(0,0,0,0.2)] border border-border-default"
    >
      {/* Icon - first column on mobile, top on desktop */}
      <div className="w-10 h-10 flex-shrink-0 md:mb-5">
        <BaseImage
          src={icon}
          width={40}
          height={40}
          alt={title}
          className="w-full h-full object-contain"
        />
      </div>

      {/* Title and Description - second column on mobile, bottom on desktop */}
      <div className="flex flex-col gap-2 md:gap-3 flex-1 md:flex-none">
        <Typography
          type="heading"
          variant="small"
          className="text-text-primary font-medium tracking-wide text-base md:text-xl leading-6 md:leading-7"
        >
          {title}
        </Typography>
        <Typography
          type="body"
          variant="small"
          className="text-text-secondary font-normal text-xs leading-5"
        >
          {description}
        </Typography>
      </div>
    </Card>
  );
};

export default FeatureCard;
